import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import url from 'url';
import { server } from '../const/axios';

export default class Home extends React.Component {

	render(): ReactElement {
		return <>
			<div className='stager'>
				<div className='imageBox'>
					<img alt='Oxford_Hack' src={url.resolve(server + '/artwork/', 'oxhack.jpg')}/>
				</div>
				<div className='infoBox'>
					<div>
						<h1>Oxford Hack 2018</h1>
						<h4>An international coding competition inviting students from pre-University to DPhil. Leader of the team 'ParliaMate', overall competition winners and winners of the 'Deloitte API Prize' and the 'Google Cloud Compute Challenge'</h4>
						<div><Link to='/projects'>PROJECT</Link></div>
					</div>
				</div>
			</div>
		</>;
	}
}
